import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useAssistedOnboarding = (adminToken) => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [activeViewSession, setActiveViewSession] = useState(null);
  const headers = { 'Authorization': `Bearer ${adminToken}`, 'Content-Type': 'application/json' };

  const loadSessions = useCallback(async () => {
    setLoading(true);
    try {
      let url = `${BACKEND_URL}/api/admin/assisted-onboarding/sessions?`;
      if (filter !== 'all') url += `status=${filter}&`;
      if (typeFilter !== 'all') url += `session_type=${typeFilter}&`;
      const res = await fetch(url, { headers, cache: 'no-store' });
      if (res.ok) setSessions(await res.json());
    } catch (err) { logger.error('Failed to load sessions:', err); }
    finally { setLoading(false); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, typeFilter]);

  useEffect(() => { loadSessions(); }, [loadSessions]);

  const handleAction = async (sessionId, action, body = {}) => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/assisted-onboarding/sessions/${sessionId}/${action}`, {
        method: 'POST', headers, body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error((await res.json()).detail);
      toast.success(`Session ${action === 'approve' ? 'approved' : action + 'ed'}`);
      loadSessions();
    } catch (err) { toast.error(err.message); }
  };

  return {
    sessions, loading, filter, setFilter,
    typeFilter, setTypeFilter,
    activeViewSession, setActiveViewSession,
    loadSessions, handleAction,
  };
};
